export default __webpack_public_path__ + "static/media/test.f2cc690e.svg";